import { render, staticRenderFns } from "./messageView.vue?vue&type=template&id=c34ec848&"
import script from "./messageView.vue?vue&type=script&lang=js&"
export * from "./messageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports